module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-1.85706bce.jpg";